import t from"./textarea";export default t;